'use client'

import * as React from 'react'
import * as SeparatorPrimitive from '@radix-ui/react-separator'

import { cn } from '@/utils/styles/cn'

type SeparatorProps = React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
    children?: React.ReactNode
}

const Separator = React.forwardRef<React.ElementRef<typeof SeparatorPrimitive.Root>, SeparatorProps>(
    ({ className, orientation = 'horizontal', decorative = true, children, ...props }, ref) => {
        if (children && orientation === 'horizontal') {
            return (
                <div className={cn('flex items-center gap-4', className)}>
                    <SeparatorPrimitive.Root
                        ref={ref}
                        decorative={decorative}
                        orientation={orientation}
                        className="flex-1 h-px bg-border"
                        {...props}
                    />
                    <span className="text-muted-foreground text-sm">{children}</span>
                    <SeparatorPrimitive.Root
                        decorative={decorative}
                        orientation={orientation}
                        className="flex-1 h-px bg-border"
                        {...props}
                    />
                </div>
            )
        }

        return (
            <SeparatorPrimitive.Root
                ref={ref}
                decorative={decorative}
                orientation={orientation}
                className={cn(
                    'shrink-0 bg-border',
                    orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
                    className
                )}
                {...props}
            />
        )
    }
)
Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator }
